import toast from 'react-hot-toast';

const defaultOptions = {
    duration: 4000,
    position: 'bottom-right',
    style: {
        padding: '12px 16px',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#fff',
    },
    className: '',
    removeDelay: 1000,
    toasterId: 'default',
};

export const toastService = {
    success: (msg) => {
        console.log('Success:', msg);
        toast.success(msg, {
            ...defaultOptions,
            style: {
                ...defaultOptions.style,
                background: '#28a745', 
            },
        });
    },
   
    error: (msg) => {
        toast.error(msg, {
            ...defaultOptions,
            style: {
                ...defaultOptions.style,
                background: '#dc3545', 
            },
        });
       
    },
    warn: (msg) => {
        console.log('Warning:', msg);
        toast(msg, {
            ...defaultOptions,
            icon: '⚠️',
            style: {
                ...defaultOptions.style,
                background: '#ffc107',
                color: '#212529', 
            },
        });
    },
    default: (msg) => {
        console.log('Info:', msg);
        toast(msg, {
            ...defaultOptions,
            style: {
                ...defaultOptions.style,
                background: '#6c757d', 
            },
        });
    },
};
